export const GameState = {
    grid: [],
    score: 0,
    shotsFired:0,
    topRowOffset:0,
    shotsCount:0,
    status: 'menu',
}
export const GameStatus = {
  MENU: 'menu',
  PLAYING: 'playing',
  GAMEOVER: 'gameOver',
};
export const COLORS = [
  '#FF3B30', // Vibrant Red
  '#4CD964', // Vibrant Green
  '#007AFF', // Vibrant Blue
  '#FFCC00', // Vibrant Yellow
  '#AF52DE', // Vibrant Purple
  '#FF9500', // Vibrant Orange
];

export const BUBBLE_RADIUS = 17;
export const ROW_HEIGHT = BUBBLE_RADIUS * 2 * 0.86;
export const GRID_COLS = 10;
export const GRID_ROWS = 16; // Increased rows for infinite mode
export const SHOTS_BEFORE_NEW_ROW = 6; // Add new row every 6 shots